import React, { forwardRef, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { GridActionsCellItem } from '@mui/x-data-grid';
import * as icons from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { get_byPatient } from 'http/components/AppointmentService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import AppLanding from 'Screens/Home/Appointments/gridMode/Landing';
import { SetPatientAppointmentsData } from 'Utils/Helpers/HandleApiData';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function PatientAppointment({ cell, row }) {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [appointment, setAppointment] = useState(null);
    const { patientAppointments, current } = useSelector((state) => ({
        patientAppointments: state.appointments.patientAppointments,
        current: state.staff.current,
    }));

    const setShowDialog = () => {
        setShow(true);
        setAppointment(null);
        getData();
    }

    const handleClose= () => {
        dispatch(SetPatientAppointmentsData(null))
        setShow(false);
    }

    const getData = async () => {
        dispatch(HandleLoading(true));
        const response = await get_byPatient(row.id);
        if(response.status) {
            await dispatch(SetPatientAppointmentsData(response.data))
            dispatch(HandleLoading(false));
        } else {
            dispatch(HandleLoading(false));
        }
    }

    useEffect(() => {
        setAppointment(patientAppointments);
    }, [patientAppointments])

    return (
        <>
            <GridActionsCellItem
                icon={<icons.JournalText size={16}/>}
                label="Appointments"
                onClick={setShowDialog}
                disabled={!current[2][1]}
                hidden={!current[2][1]}
            />
            {
                show &&
                <Dialog
                    open={show}
                    TransitionComponent={Transition}
                    keepMounted
                    fullWidth={true}
                    maxWidth={'lg'}
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-appointment-edit"
                >
                <DialogTitle className=''>
                    {`نوبت‌های بیمار (${appointment ? appointment.length : 0})`}
                    <div className='close-btn' onClick={handleClose}>
                        <icons.X/>
                    </div>
                </DialogTitle>
                    <DialogContent>
                        <div className='flex-row-center-center w-100 mb-2'>
                            {
                                show && 
                                <AppLanding
                                    data={appointment}
                                    patient={row.id}
                                />
                            }
                        </div>
                    </DialogContent>
                </Dialog>
            }
        </>
    );
}